<template>
  <div class="appWrapper">
    <SideBar/>

    <div class="mainContent">
      <transition name="slide" mode="out-in">
        <!-- If there is type id we need key for page refresh beetween types -->
        <router-view :key="$route.params.typeId" v-if="$route.params.typeId"/>
        <router-view v-else/>
      </transition>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/Sidebar.vue'
import * as types from '@/store/types.js'
import Type from '@/model/Type'
import {loadResource} from '@/helpers/resource'

export default {
  name: 'Intro',
  components: {
    SideBar
  },
  created () {
    if (this.$route.query.search) {
      this.$store.dispatch(types.ACTIVE_LANGUAGE, this.$route.query.search.language)
    }
    loadResource(Type, types.GET_ALL_TYPES, types.IS_LOADING_TYPES)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue